import classNames from 'classnames';
import { useHits, useInstantSearch } from 'react-instantsearch';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useScreenSize } from '@sorare/core/src/hooks/device/useScreenSize';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import {
  AnimatedGrid,
  AnimatedGridItem,
  Grid,
  GridItem,
  GridOverlayLoadingIndicator,
} from 'components/market/Grid';
import { CardResultsProps } from 'searchCards/AdvancedCardSearch/types';

import { CommonPlayerPreview } from '../CommonPlayerPreview';
import { CommonCardsGrid_composeTeamBenchObjectInterface } from './__generated__/types.graphql';

export const CommonCardsGrid = ({
  onStatsClick,
  sport,
}: CardResultsProps & {
  onStatsClick: (playerSlug: string) => void;
}) => {
  const { up: isTabletOrAbove } = useScreenSize('tablet');
  const {
    flags: { useMlbOffseason = false },
  } = useFeatureFlags();

  const { status } = useInstantSearch();
  const { items } = useHits<
    CommonCardsGrid_composeTeamBenchObjectInterface & {
      __typename: 'ComposeTeamBenchCommonPlayer';
    }
  >();

  const flipKey = `${items?.map(item => item.anyPlayer.slug).join('-')}${'-showDesktopFilter'}`;

  if (sport === Sport.FOOTBALL) return null;
  if (sport === Sport.BASEBALL && useMlbOffseason) {
    return null;
  }

  const GridComponent = isTabletOrAbove ? AnimatedGrid : Grid;

  const GridItemComponent = isTabletOrAbove ? AnimatedGridItem : GridItem;
  const loading = status === 'loading' || status === 'stalled';

  return (
    <>
      <GridComponent
        staggerConfig={{
          default: {
            speed: 0.4,
          },
        }}
        flipKey={flipKey}
        className={classNames({
          twoColumnsOnMobile: !isTabletOrAbove,
        })}
      >
        {items.map((commonPlayer, index) => {
          return (
            <GridItemComponent
              key={commonPlayer.id}
              flipId={commonPlayer.anyPlayer.slug}
            >
              <CommonPlayerPreview
                commonPlayer={commonPlayer}
                onStatsClick={() => onStatsClick(commonPlayer.anyPlayer.slug)}
                showPlayerCostHighlight={index === 0}
              />
            </GridItemComponent>
          );
        })}
      </GridComponent>
      {loading && <GridOverlayLoadingIndicator />}
    </>
  );
};
